let api = 'https://api.docircuit.org:3001';
let home = 'https://center.docircuit.org';
export const image_version = '20220919';

if(process.env.NODE_ENV === 'development') {
  // load .env.local
  if(process.env.REACT_APP_API !== undefined) {
    api = process.env.REACT_APP_API;
    home = process.env.REACT_APP_HOME;
  }
}

export const loginState = {
  mcd: "",
  level: "",
};

export const configState = {
    cid: 'CID00000009',
    name: '두써킷 (정관점)',
    api:api,
    home: home,
    userCode: 'imp76426114',
    tierCode : 'G10',    
}

// export const gohyeonState = {
//   cid: 'CT17X10111035.huwy5',
//   name: '두써킷 (고현점)',
//   api:api,
//   home: home,
//   userCode: 'imp76426114',
//   tierCode : 'G10',    
// }


// userCode: 'iamport',
// tierCode : ''
